globalThis.Game = class Game {
  constructor(_, context, id) {
    globalThis.GAME = this;
    this.context = context;
    this.id = id;
    this.abort = new AbortController();
    this.client = new Client(
      ["ws", "wss"].includes(context) ? new URL(`${context}://${id}`) : null,
    );
    this.world = new World();
    this.topbar = new Topbar();
    this.menu = new Menu();
    this.connection_list = new ConnectionList();
    this.chat = new Chat();
    this.status = new Status();
    this.camera = new Camera();
    this.pen = new Pen();
    document.body.style.overflow = "hidden";
    addEventListener("contextmenu", preventdefault, this.abort);
    if (this.client.server.open) this.onOpen();
    else
      this.client.server.addEventListener(
        "open",
        this.onOpen.bind(this),
        this.abort,
      );
  }

  remove() {
    document.body.style.overflow = "";
    this.abort.abort();
    this.client.remove();
    this.topbar.remove();
    this.menu.remove();
    this.connection_list.remove();
    this.chat.remove();
    this.status.remove();
    this.camera.remove();
    this.pen.remove();
    this.world.remove();
    delete globalThis.GAME;
  }

  onOpen() {
    if (this.context === "local") {
      if (this.id) globalThis.STORE.loadWorldFromSave(this.id);
    }
  }
};
